import { USStatesList } from '~/models';
import type { ExtendedVuetifyListItem } from '~/types';


export function useUSStates() {
    const props = {
        disabled: true,
        baseColor: 'on-surface',
        variant: 'tonal',
        class: 'opacity-100 text-center mt-4',
        density: 'compact'
    };

    const getGroupHeader = (title: string) =>({ title, props });

    function getGroupedStatesList(): ExtendedVuetifyListItem[] {
        const items = USStatesList.slice(0) as ExtendedVuetifyListItem[];
        const idx = items.findIndex((item) => item.type !== 'State');
        items.splice(idx, 0, getGroupHeader('Territories'));
        return items;
    }
    
    return {
        getGroupedStatesList
    };
}
